import { useQuery } from '@tanstack/react-query';

import { CommonClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const commonClient = new CommonClient(apiBaseUrl);

function useGetAirports() {
  return useQuery({
    queryKey: [queryKeys.Common.AllAirports],
    queryFn: () => commonClient.getAllAirports(),
    staleTime: 5 * 60 * 1000,
  });
}

export default useGetAirports;
